import React from 'react';

import { FlexBox, Typography } from '@jimdo/ui';
import './viewHeader.scss';

interface Props {
  title: string;
  headlineText: string;
  sublineText?: string;
}

const ViewHeader: React.FC<Props> = (props: Props) => {
  return (
    <FlexBox flexDirection="column" alignItems="center" marginBottom="xxxl">
      <Typography variant="bodySmall" align="center">
        {props.title}
      </Typography>

      <Typography
        className="viewheader-component__title"
        variant="title"
        align="center"
        marginBottom="zero"
      >
        {props.headlineText}
      </Typography>

      {props.sublineText && (
        <div
          className="viewheader-component__subline"
          dangerouslySetInnerHTML={{ __html: props.sublineText }}
        />
      )}
    </FlexBox>
  );
  // tslint:enable react-no-dangerous-html
};

export default ViewHeader;
